import React from "react";
import { Star, Phone, MessageCircle, MapPin, Sparkles } from "lucide-react";
import { SITE, PHOTOS } from "@/lib/site-data";
import VideoEmbed from "@/components/VideoEmbed";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-orange-50/60 via-white to-white" data-testid="hero-section">
      <div className="pointer-events-none absolute -top-32 -right-32 h-96 w-96 rounded-full bg-orange-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -left-20 h-96 w-96 rounded-full bg-emerald-100/50 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-14 md:pt-20 pb-16 md:pb-24 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="fade-up">
          <div className="inline-flex items-center gap-2 bg-white/70 backdrop-blur border border-orange-100 px-4 py-2 rounded-full text-sm font-medium text-stone-700 shadow-sm">
            <Sparkles className="w-4 h-4 text-orange-600" />
            <span>+20 anos transformando vidas em Cabo Frio</span>
          </div>

          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-stone-900 leading-[1.05]" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Quiropraxia, o <span className="text-orange-600">segredo</span>
            <br className="hidden sm:block" /> para uma vida <span className="text-orange-600">sem dores.</span>
          </h1>

          <p className="mt-6 text-lg md:text-xl text-stone-600 leading-relaxed max-w-xl">
            <strong className="text-stone-800">Clínica Vida Saudável</strong> • {SITE.professional} —
            atendimento humano, técnico e acolhedor para você voltar a se mover sem dor.
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-1.5 bg-yellow-50 px-3.5 py-2 rounded-full border border-yellow-100">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-yellow-500 text-yellow-500" />
              ))}
              <span className="ml-1 text-sm font-bold text-yellow-700">4,9</span>
              <span className="text-sm text-yellow-700/80">({SITE.reviewsCount} avaliações)</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-stone-600">
              <span className="relative flex h-2.5 w-2.5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
              </span>
              Aberto hoje — 09:00 às 17:00
            </div>
          </div>

          <div className="mt-9 flex flex-col sm:flex-row gap-3.5">
            <a
              href={SITE.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2.5 bg-orange-600 hover:bg-orange-700 text-white px-7 py-4 rounded-2xl font-semibold text-base shadow-[0_10px_30px_rgba(234,88,12,0.35)] hover:-translate-y-0.5 transition-all"
            >
              <MessageCircle className="w-5 h-5" />
              Falar no WhatsApp
            </a>
            <a
              href="#sobre"
              data-testid="hero-saiba-mais-btn"
              className="inline-flex items-center justify-center gap-2 bg-white text-stone-900 border border-stone-200 hover:border-orange-600 hover:text-orange-600 px-7 py-4 rounded-2xl font-semibold text-base transition-all"
            >
              Saiba mais
            </a>
          </div>

          <div className="mt-8 flex items-center gap-5 text-sm text-stone-600">
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-orange-600" /> {SITE.phone}
            </div>
            <div className="hidden sm:flex items-center gap-2">
              <MapPin className="w-4 h-4 text-orange-600" /> Cabo Frio – RJ
            </div>
          </div>
        </div>

        {/* Right - editable shorts video */}
        <div className="relative fade-up flex justify-center" style={{ animationDelay: "0.15s" }}>
          <div className="relative w-full max-w-[340px] sm:max-w-[380px] shadow-[0_30px_70px_-20px_rgba(234,88,12,0.35)]">
            <VideoEmbed storageKey="hero-video" posterImage={PHOTOS.heroAdjust} aspect="shorts" label="Apresentação da clínica" />
          </div>

          {/* Floating badge */}
          <div className="absolute -top-4 -left-4 sm:-left-8 bg-white rounded-2xl shadow-xl border border-stone-100 px-4 py-3 float-anim z-10">
            <div className="text-xs text-stone-500 uppercase tracking-wide">+5.000 atendimentos</div>
            <div className="text-lg font-bold text-stone-900">com excelência</div>
          </div>
        </div>
      </div>
    </section>
  );
}
